export { RatesV2Connected as RatesV2 } from './container';
